
import { Component, Vue, Watch } from 'vue-property-decorator'
import { CustomerRegister } from '../lib/models/CustomerRegister'
import { Rally } from '../lib/models/Rally'
import { RallyRound } from '../lib/models/RallyRound'
import { Team } from '../lib/models/Team'
import { User } from '../lib/models/User'

import { DateUtils } from '@/lib/utils/DateUtils'

import BacAlert from '@/components/BacAlert.vue'
import BacAccordeon from '@/components/BacAccordeon.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import BacButton from '@/components/BacButton.vue'

import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import UIkit from 'uikit'
import { parsePhoneNumber } from 'libphonenumber-js'
import { Country } from '../lib/models/Country'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacAlert,
    BacAccordeon,
    BacModal,
    BacInput,
    BacButton,
    VuePhoneNumberInput
  }
})
export default class RegisterState extends Vue {
  customerRegister: CustomerRegister = new CustomerRegister();
  customerRegisterRally: Rally = new Rally();
  customerRegisterRallyRound: RallyRound = new RallyRound();
  customerRegisterMembers: CustomerRegister[] = [];

  countries: Country[] = [];

  selectedCustomer = new User();

  phone: any = {};
  phoneNumberInputModel = ''; // needs to exist even when not used, does not work without a v-model even though you have to use the update event anyway, made a github issue about it: https://github.com/LouisMazel/vue-phone-number-input/issues/163
  phoneNumber = '';
  defaultCountry = 'AT';

  isAddingMemberLoading = false;
  selectedCustomerRegister: CustomerRegister = new CustomerRegister();

  newPaidMemberPrice = -1
  lastPaidMemberPrice = -1

  @Watch('phone')
  onPhoneChanged () {
    this.phoneNumber = this.phone.formatInternational
  }

  get isCurrentUserTeamlead () {
    if (!this.$store.state.LoggedInUser.user) {
      return false
    }
    return this.$store.state.LoggedInUser.user.id === this.customerRegister.customerId
  }

  get shareTitle () {
    return `${this.customerRegisterRally.name}.
Wir sind dabei!`
  }

  get shareText () {
    return `Auch bereit für ein Abenteuer?
www.backroadclub.com
Back Road Club`
  }

  get isMobile () {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ]

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })
  }

  get unpaidMembersPrice () {
    let unpaidPrice = 0
    this.customerRegisterMembers.forEach(member => {
      if (member.price) {
        unpaidPrice += member.price
      }
    })
    return unpaidPrice
  }

  get isAndroid () {
    return navigator.userAgent.match(/Android/i)
  }

  get isChrome () {
    return (window as any).chrome !== undefined
  }

  @Watch('selectedCustomer')
  onSelectedCustomerChange () {
    if (this.selectedCustomer.telephone) {
      const parsedPhoneNumber = (parsePhoneNumber as any)(
        this.selectedCustomer.telephone,
        { defaultCountry: 'AT' }
      );
      (this.phoneNumberInputModel as any) = parsedPhoneNumber.nationalNumber;
      (this.defaultCountry as any) = parsedPhoneNumber.country
    }
  }

  async shareCustom () {
    const res = await Http.request(this.confirmationPictureUrl)
    const blob = await res.blob()
    const file = new File([blob], 'dot.png', { type: 'image/png', lastModified: new Date().getTime() })

    const shareData = {
      text: `${this.shareTitle}
${this.shareText}`,
      files: [file]
    }
    await (navigator as any).share(shareData)
  }

  tshirtSizes = [
    'S - Herren',
    'M - Herren',
    'L - Herren',
    'XL - Herren',
    'XXL - Herren',
    '3XL - Herren',
    '4XL - Herren',
    '5XL - Herren',
    'XS - Damen',
    'S - Damen',
    'M - Damen',
    'L - Damen',
    'XL - Damen',
    'XXL - Damen'
  ];

  mounted () {
    this.$store.dispatch('loadLoggedInUser')
    this.loadCustomerRegister()
    this.loadCountries()
  }

  get printableDateAdded () {
    if (this.customerRegister.dateAdded) {
      return DateUtils.isoToMysql(this.customerRegister.dateAdded)
    } else {
      return ''
    }
  }

  get canStillEditCustomerRegister () {
    if (!this.customerRegisterRallyRound.customerRegisterEditableTil) {
      return false
    }
    const maxAddDate = new Date(this.customerRegisterRallyRound.customerRegisterEditableTil)
    if (!(maxAddDate instanceof Date) || isNaN(maxAddDate.getTime())) {
      return false
    }

    return maxAddDate.getTime() > new Date().getTime()
  }

  get price () {
    if (this.customerRegister.price) {
      const price = this.customerRegister.price
      /* PAID members are calculated into total price, see monday item: 4244356861
        this.customerRegisterMembers.forEach((memberCustomerRegister) => {
        if (memberCustomerRegister.price) {
          price += memberCustomerRegister.price
        }
      }) */
      return price.toFixed(2)
    } else {
      return 0
    }
  }

  get fullConfirmationPictureUrl () {
    return `${window.location.protocol}//${window.location.host}${this.confirmationPictureUrl}`
  }

  get confirmationPictureUrl () {
    return `/api/customer-register/${this.$route.params.cuid}/render-confirmation`
  }

  get sharingEnabled () {
    // return window.location.href.endsWith('sharingEnabled')
    return true
  }

  get browserSupportsNativeShare () {
    return navigator.share
  }

  @Watch('customerRegister')
  async onCustomerRegisterChange () {
    this.lastPaidMemberPrice = (await (await Http.request(`/api/customer-register/${this.$route.params.cuid}/last-paid-member-price`)).json()).price
    this.newPaidMemberPrice = Math.round((await (await Http.request(`/api/orders/${this.$route.params.cuid}/new-member-price`)).json()).price * 100) / 100
  }

  async loadCustomerRegister () {
    this.customerRegister = await CustomerRegister.get(this.$route.params.cuid)
    if (this.customerRegister.rallyId) {
      this.customerRegisterRally = await Rally.get(
        this.customerRegister.rallyId
      )
    } else {
      console.error('customerRegister.rallyId is false, should never happen!')
    }

    if (this.customerRegister.rallyRoundId) {
      this.customerRegisterRallyRound = await RallyRound.get(
        this.customerRegister.rallyRoundId
      )
    } else {
      console.error(
        'customerRegister.rallyRoundId is false, should never happen!'
      )
    }
    this.customerRegisterMembers = await CustomerRegister.getAll({
      params: [`${this.$route.params.cuid}/members`]
    })
  }

  async loadCountries () {
    this.countries = await Country.getAll({})
  }

  async changeTeamlead () {
    await Http.request(`/api/customer-register/change-teamlead/${this.customerRegister.id}/${this.selectedCustomerRegister.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.selectedCustomer)
    })
    await this.loadCustomerRegister()
  }

  saveTeammember () {
    const errors = []
    if (!this.selectedCustomer.firstname) {
      errors.push('Bitte gib einen Vornamen ein!')
    }
    if (!this.selectedCustomer.lastname) {
      errors.push('Bitte gib einen Nachnamen ein!')
    }
    if (!this.selectedCustomer.email) {
      errors.push('Bitte gib eine E-Mail ein!')
    }
    if (!this.phoneNumberInputModel) {
      errors.push('Bitte gib eine Telefonnummer ein!')
    }
    if (this.phoneNumberInputModel.length < 6) {
      errors.push('Bitte überprüfe deine Telefonnummer!')
    }
    if (!this.selectedCustomer.birthday) {
      errors.push('Bitte gib den Geburtstag des Teammitglieds ein!')
    }
    if (!this.selectedCustomer.sex) {
      errors.push('Bitte wähle das Geschlecht des Teammitglieds aus!')
    }
    if (!(this.selectedCustomer as any).tshirtsize) {
      errors.push('Bitte wähle die T-Shirt Größe des Teammitglieds aus!')
    }
    if (this.selectedCustomer.email && this.$store.state.LoggedInUser.user.email.toLowerCase() === this.selectedCustomer.email.toLowerCase()) {
      errors.push('Bitte gib die E-Mail Adresse des Teammitglieds an, nicht deine eigene!')
    }
    if (!this.selectedCustomer.id && this.customerRegisterMembers.find(customerRegister => {
      return customerRegister.email === this.selectedCustomer.email
    })) {
      errors.push('Du hast bereits ein Teammitglied mit dieser E-Mail Adresse hinzugefügt!')
    }
    errors.forEach(error => {
      UIkit.notification({
        message: error,
        status: 'danger',
        timeout: 5000,
        pos: 'bottom-center'
      })
    })
    if (errors.length) {
      return
    }
    this.isAddingMemberLoading = true
    if (this.selectedCustomer.id) {
      this.editSaveTeamMember()
    } else {
      this.addNewTeamMember()
    }
  }

  async editSaveTeamMember () {
    if (!this.phoneNumber) {
      delete this.selectedCustomer.telephone
    } else {
      this.selectedCustomer.telephone = this.phoneNumber
    }
    const res = await Http.request(
      `/api/customer-register/${this.$route.params.cuid}/members/${this.selectedCustomerRegister.id}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.selectedCustomer)
      }
    )

    if (!res.ok) {
      const error = (await res.json()).error
      if (error === 'invalid-email') {
        UIkit.notification({
          message: 'Bitte überprüfe die E-Mail!',
          status: 'danger',
          timeout: 5000,
          pos: 'bottom-center'
        })
      } else if (error === 'user-already-exists') {
        UIkit.notification({
          message: 'Ein anderer Nutzer mit dieser E-Mail Adresse existiert bereits!',
          status: 'danger',
          timeout: 5000,
          pos: 'bottom-center'
        })
      }
    } else {
      UIkit.modal('#edit-member-modal').hide()
    }
    await this.loadCustomerRegister()

    if (this.customerRegister.teamId) {
      // team already exists, update customertoteam too
      await this.updateCustomerToTeam()
    }
    setTimeout(() => { this.isAddingMemberLoading = false }, 1000)
  }

  async addNewTeamMember () {
    this.selectedCustomer.telephone = this.phoneNumber
    if (this.selectedCustomer.email) {
      this.selectedCustomer.email = this.selectedCustomer.email.trim()
    }
    const res = await Http.request(
      `/api/customer-register/${this.$route.params.cuid}/members`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.selectedCustomer)
      }
    )
    if (!res.ok) {
      const error = (await res.json()).error
      if (error === 'invalid-email') {
        UIkit.notification({
          message: 'Bitte überprüfe die E-Mail!',
          status: 'danger',
          timeout: 5000,
          pos: 'bottom-center'
        })
      }
    } else {
      UIkit.modal('#edit-member-modal').hide()
    }

    await this.loadCustomerRegister()
    if (this.customerRegister.teamId) {
      // team already exists, update customertoteam too
      await this.updateCustomerToTeam()
    }
    setTimeout(() => { this.isAddingMemberLoading = false }, 1000)
  }

  async deleteMember () {
    await Http.request(`/api/customer-register/${this.selectedCustomerRegister.id}`, {
      method: 'DELETE'
    })
    await this.loadCustomerRegister()
    if (this.customerRegister.teamId) {
      // team already exists, update customertoteam too
      await this.updateCustomerToTeam()
    }
  }

  async openAddTeamMemberModal () {
    if (!this.customerRegister || !this.customerRegister.teamSize || !this.customerRegisterMembers) {
      return
    }
    if (this.customerRegister.teamSize > this.customerRegisterMembers.length + 1) {
      UIkit.modal('#edit-member-modal').show()
    } else {
      UIkit.modal('#confirm-add-paid-member-modal').show()
    }
    this.selectedCustomer = new User()
  }

  async setSelectedCustomerRegister (customerRegister: CustomerRegister) {
    this.selectedCustomerRegister = customerRegister
    if (customerRegister.customerId) {
      this.selectedCustomer = await User.get(customerRegister.customerId);
      (this.selectedCustomer as any).tshirtsize = this.selectedCustomerRegister.tshirtsize
    } else {
      console.error(
        'Customer Register has no customerId, should never happen!'
      )
    }
  }

  async updateCustomerToTeam () {
    const customerIds = [this.customerRegister.customerId]

    this.customerRegisterMembers.forEach(member => {
      customerIds.push(member.customerId)
    })

    const res = await Http.request(`/api/team/${this.customerRegister.teamId}/customers`, {
      method: 'PUT',
      body: JSON.stringify({ customers: customerIds }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}
